import React from "react";

export const ArrowRight = (props) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.2808 3.81687L8.37619 6.72432V4.3149H0.496094V3.31884H8.37619V0.909424L11.2808 3.81687Z"
      fill="#3176F2"
    />
  </svg>
);

export const ArrowRight2 = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9 18L15 12L9 6" stroke="#767778" strokeWidth="2" />
  </svg>
);
